export default __webpack_public_path__ + "static/media/img_ahorro_yapp.c2f5944e.svg";